/* eslint-disable  */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import useData from '../../hooks/useData';
import { useUserContext } from '../../context/userContext';
import { useRolesPermissionsContext } from '../../context/rolePermissionContext';
import {
  Box,
  TextField,
  Paper,
  Typography,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  Link,
} from '@mui/material';

import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import styles from './LoginFormStyle';

const Password = ({ email, isLogin, backToEmail }) => {
  const { createPassword, login } = useAuth();
  const { getAllRoles, getAllPermissions } = useData();
  const { setUserInfo } = useUserContext();
  const { setRoles, setPermissions } = useRolesPermissionsContext();
  const [loginError, setLoginError] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  const classes = styles(theme);
  const emailId = email;
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
  } = useForm();

  /* Password */
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const handleClickShowPassword = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };
  const emailValue = watch('email');

  const [showErrorMessage, setShowErrorMessage] = useState(true);
  const handleErrorMessageClose = () => {
    console.log('Close Error Message');
    setShowErrorMessage(false);
  };

  /* Checkbox */
  const [checked, setChecked] = useState(false);
  const handleCheckboxChange = (event) => {
    setChecked(event.target.checked);
  };

  const onSubmit = async (data, event) => {
    event.preventDefault();
    const { password } = data;

    if (!isLogin) {
      const response = await createPassword({ password, email: emailId });
    } else {
      const response = await handleLogin({ password, email: emailId });
    }
    reset();
  };

  const handleLogin = async (data, isLogin) => {
    console.log('handleLogin function called');
    const response = await login(data);
    if (response && response.data && response.data.success) {
      /* eslint-disable */
      const { email, first_name, last_name, roles_permissions } = response.data;
      console.log(first_name, email, last_name, roles_permissions, 4545);
      setUserInfo({
        email: email,
        firstName: first_name,
        lastName: last_name,
        role: {
          id: roles_permissions.id,
          name: roles_permissions.name,
        },
        permissions: roles_permissions.permissions,
      });
      const rolesData = await getAllRoles();
      const permissionsData = await getAllPermissions();
      console.log('Roles Data:', rolesData);
      console.log('Permissions Data:', permissionsData);
      setRoles(rolesData.data);
      setPermissions(permissionsData.data);
      navigate('/homepage');
    } else {
      setLoginError(response || true);
    }
    reset();
  };

  return (
    <Grid
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="stretch"
      sx={classes.LoginContainer}
    >
      <Grid item xs={12}>
        <Box sx={classes.LoginBox}>
          <Paper sx={classes.LoginFormPaper} component="form" onSubmit={handleSubmit(onSubmit)}>
            {/* <form onSubmit={handleSubmit(onSubmit)}> */}
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12}>
                <Button
                  onClick={() => {
                    console.log('Back to Email');
                    backToEmail();
                  }}
                  variant="text"
                  startIcon={<ArrowBackIcon />}
                  color="primary"
                >
                  Back to Email
                </Button>
              </Grid>
              <Grid item xs={12}>
                <Typography
                  variant="h1"
                  component="div"
                  sx={[classes.LoginHeading]}
                  tabIndex="0"
                  role="heading"
                  aria-label="Resurgens Security Services Administrative Portal"
                >
                  Resurgens Security Services Administrative Portal
                </Typography>
              </Grid>
              <Grid item xs={12} mt={3}>
                <Typography variant="h2" component="div">
                  {isLogin ? 'Log In' : 'Create Password'}
                </Typography>
                {!isLogin && (
                  <>
                    <Typography variant="body2" component="div" sx={[classes.LoginFormInfo]}>
                      This is the password you will use to log in.
                    </Typography>
                  </>
                )}
              </Grid>
              <Grid item xs={12}>
                <TextField
                  {...register('password', {
                    required: 'Password is required',
                    minLength: {
                      value: 8,
                      message: '8 characters minimum',
                    },
                    maxLength: {
                      value: 50,
                      message: 'Password exceeds max length of 50 characters',
                    },
                    // pattern: {
                    //   value: /^(?=.*[A-Z])(?=.*[!@#$%^&*()_+{}|;':",.<>?/\\])(.{8,24})$/,
                    //   message: 'Password criteria not met',
                    // },
                    validate: {
                      hasUpperCase: (value) =>
                        /[A-Z]/.test(value) || 'At least one uppercase character',
                      hasLowerCase: (value) =>
                        /[a-z]/.test(value) || 'At least one lowercase character',
                      hasNumber: (value) => /\d/.test(value) || 'At least one number ',
                      hasSpecialCharacter: (value) =>
                        /[!@#$%^&*()_+{}|;':",.<>?/\\]/.test(value) ||
                        'At least one special character ',
                    },
                  })}
                  // tabindex="2"
                  role="textbox"
                  className="commonInputFld"
                  label="Password"
                  name="password"
                  type={isPasswordVisible ? 'text' : 'password'}
                  id="outlined-basic-2"
                  variant="outlined"
                  fullWidth
                  error={!!errors.password}
                  helperText={errors.password?.message}
                  InputProps={{
                    'aria-label': 'Password', // Aria-label provides an accessible label for screen readers
                    'aria-required': true, // Indicates that the input is required
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label={isPasswordVisible ? 'View Password' : 'Hide Password'}
                          onClick={() => handleClickShowPassword()}
                        >
                          {isPasswordVisible ? <VisibilityIcon /> : <VisibilityOffIcon />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <Button
                  disableFocusRipple
                  aria-label="Log In"
                  role="button"
                  fullWidth
                  variant="contained"
                  color="primary"
                  sx={classes.loginButton}
                  // disabled={isSubmitting}
                  type="submit"
                >
                  Log IN
                </Button>
              </Grid>
              {isLogin && (
                <>
                  <Grid item xs={12}>
                    <Link
                      onClick={() => navigate('/forgot-password', { state: { email: emailId } })}
                    >
                      Forgot password?
                    </Link>
                  </Grid>
                </>
              )}
            </Grid>
            {/* </form> */}
          </Paper>
        </Box>
      </Grid>
    </Grid>
  );
};

Password.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  loginError: PropTypes.bool.isRequired,
  email: PropTypes.string.isRequired,
};

export default Password;
